export const MENU_BAR_HEIGHT = 25;
